module.exports = "/images/vendor/desiigner-svg/svg/places/opera.svg?e5ae1976c5a1288117fa3550e188ab51";